import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProgressComponent } from './shared/progress/progress.component';

const routes: Routes = [
  { path: 'seguros-de-salud/calcular', loadChildren: () => import('./customer-journey/customer-journey.module').then((mod) => mod.CustomerJourneyModule) },
  { path: 'datos-comparativa', loadChildren: () => import('./customer-journey/customer-journey.module').then((t) => t.CustomerJourneyModule) },
  { path: 'modifica-tus-datos', loadChildren: () => import('./section-wise/section-wise.module').then((t) => t.SectionWiseModule) },
  { path: 'modifica-tus-datos/:id', loadChildren: () => import('./section-wise/section-wise.module').then((t) => t.SectionWiseModule) },
  { path: 'email-landing', loadChildren: () => import('./email-landing/email-landing.module').then((t) => t.EmailLandingModule) },
  // Redirect all old email landings to the new email-landing module
  {
    path: 'email-quotes-landing.aspx',
    redirectTo: 'email-landing/quote'
  },
  {
    path: 'email-quotes-update.aspx',
    redirectTo: 'email-landing/update'
  },

  { path: 'progress', component: ProgressComponent, pathMatch: 'full' },

  { path: 'modifica-tus-datos.aspx', redirectTo: 'modifica-tus-datos', pathMatch: 'full' },
  { path: 'datos-comparativa.aspx', redirectTo: 'datos-comparativa/Q1', pathMatch: 'full' },
  { path: 'cuestionarios-salud', redirectTo: 'cuestionarios-salud.html' },
  { path: '', redirectTo: 'datos-comparativa/Q1', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
